import {useNavigate, useLocation} from "react-router-dom";
import {Typography, Button} from "@mui/material";
import {UI_ACTION_CREATORS} from "../../redux/features/ui/ui-slice";
import {useDispatch} from "react-redux";

const SidebarLink = ({path, label}) => {
    const {pathname} = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleClick = () => {
        navigate(path);
        dispatch(UI_ACTION_CREATORS.toggleDrawer(false));
    }

    return (
        <Button
            sx={{
                textDecoration: 'none',
                width: "100%",
                backgroundColor: path === pathname ? "rgba(175,121,93,0.3)" : false,
                borderRadius: 1,
                padding: 1,
                display: "block"
            }}
            onClick={handleClick}>
            <Typography
                variant="body2"
                sx={{
                    color: path === pathname ? "secondary.main" : "text.secondary",
                    fontWeight: path === pathname ? 700 : 400,
                    textTransform: "uppercase"
                }}>{label}</Typography>
        </Button>
    )
}

export default SidebarLink;